import { render, staticRenderFns } from "./AssignGraduationProfileDialog.vue?vue&type=template&id=3bbac635"
import script from "./AssignGraduationProfileDialog.ts?vue&type=script&lang=ts&external"
export * from "./AssignGraduationProfileDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./AssignGraduationProfileDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports